query GroupDepartments {
  departments(orderBy: [NAME_ASC, PRIMARY_KEY_ASC]) {
    nodes {
      id
      name
    }
  }
}
